/* eslint-disable no-restricted-syntax */
/* eslint-disable no-prototype-builtins */
import { Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { usePlantaoVendas } from "contexts/PlantaoVendasContext";
import { converterObjetoParaString } from "../../../../hooks/convertObjectToString";
import { useIndicadores } from "../../../../services/api/AppWeb_Atendimento/indicadores";
import { AuthState } from "../../../../store/ducks/auth/types";

import IndicatorCard from "./components/IndicatorCard";
import * as Styles from "./styles";

interface AnyObject {
  [key: string]: any;
}

interface Props {
  filter: any;
}

const completedCalls: React.FC<Props> = (props) => {
  const { plantaoVendas, codigoCargo2013, supervisorProduto } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);
  const [filtros, setFiltros] = useState<any>(null);
  const { plantaoVendas: pdvSelected } = usePlantaoVendas();
  const {
    data: dataIndicadores,
    refetch: refetchIndicadores,
    isFetching: isLoadingAtendimentos,
  } = useIndicadores({
    queryKey: "listar_indicadores",
    idLocalVendas: supervisorProduto
      ? pdvSelected?.value || undefined
      : plantaoVendas?.id,
    params:
      filtros === null
        ? converterObjetoParaString({ PaginaAtual: 1 })
        : converterObjetoParaString(props.filter),
  });

  useEffect(() => {
    console.log("props.filter", props.filter);
  }, [props.filter]);

  function transformObject(obj: AnyObject): AnyObject {
    const transformedObj: AnyObject = {};

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const fieldValue = obj[key];

        if (
          fieldValue &&
          typeof fieldValue === "object" &&
          "value" in fieldValue
        ) {
          transformedObj[key] = fieldValue.value;
        } else {
          transformedObj[key] = fieldValue;
        }
      }
    }

    return transformedObj;
  }

  const getFilter = async () => {
    const filtross: any = await localStorage.getItem("@sell.it/PDVFilters");
    const filtros2Json = JSON.parse(filtross);
    filtros2Json.PaginaAtual = 1;
    if (filtros2Json) {
      setFiltros(transformObject(filtros2Json));
    } else {
      setFiltros(props.filter);
    }
  };

  useEffect(() => {
    getFilter();
  }, [props.filter]);

  useEffect(() => {
    if (supervisorProduto && !pdvSelected?.value) {
      return;
    }
    if (!supervisorProduto || (supervisorProduto && pdvSelected?.value)) {
      refetchIndicadores();
    }
  }, [filtros, pdvSelected]);

  return (
    <Styles.Container>
      <Styles.Title>Indicadores</Styles.Title>
      {!isLoadingAtendimentos ? (
        <IndicatorCard data={dataIndicadores?.data[0]} />
      ) : (
        <Skeleton
          variant="rounded"
          width="100%"
          height={400}
          style={{ marginTop: 8 }}
        />
      )}
    </Styles.Container>
  );
};

export default completedCalls;
